module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-main",
    class: _vm.showMap,
    on: {
      "mouseup": _vm.onMouseUp
    }
  }, [_c('div', {
    staticClass: "l-submain",
    class: _vm.currentSize,
    on: {
      "mousemove": _vm.l_submain_onMouseMove,
      "mouseleave": _vm.l_submain_onMouseLeave
    }
  }, [_c('div', {
    staticClass: "l-table-wrap"
  }, [_c('div', {
    staticClass: "l-table-bar "
  }, [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-2 white",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('span', {
    staticClass: "body-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("watersystem.list")) + ":\n            ")]), _vm._v(" "), _c('v-btn', {
    class: [_vm.isCustomerFormat ? 'blue lighten-5 blue--text' : 'grey--text'],
    attrs: {
      "round": "",
      "depressed": "",
      "small": ""
    },
    on: {
      "click": _vm.getLocations
    }
  }, [_c('v-icon', {
    staticClass: "body-1"
  }, [_vm._v("place")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("watersystem.customer")))])], 1), _vm._v(" "), _c('v-btn', {
    class: [_vm.isCustomerFormat ? 'grey--text' : 'blue lighten-5 blue--text'],
    attrs: {
      "round": "",
      "depressed": "",
      "small": ""
    },
    on: {
      "click": _vm.getAllFiltrationSystems
    }
  }, [_c('v-icon', {
    staticClass: "caption"
  }, [_vm._v("smartphone")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("watersystem.device")))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCustomerFormat),
      expression: "isCustomerFormat"
    }]
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "pt-2 pb-2 caption elevation-1",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs1": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'status',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.status")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('status', _vm.ordersLocations)))])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs1": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'mapinfo',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.mapinfo")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('mapinfo', _vm.ordersLocations)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'locationName',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.customer-name")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('locationName', _vm.ordersLocations)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'organizationName',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.organization-name")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('organizationName', _vm.ordersLocations)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'services',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.service")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('services', _vm.ordersLocations)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'devices',
          _vm.ordersLocations,
          _vm.defaultOrdersLocations,
          _vm.locations)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.device")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('devices', _vm.ordersLocations)))])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCustomerFormat),
      expression: "!isCustomerFormat"
    }]
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "pa-2 caption elevation-1",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'status',
          _vm.ordersDevices,
          _vm.defaultOrdersDevices,
          _vm.devices)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.status")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('status', _vm.ordersDevices)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'filtrationSystemName',
          _vm.ordersDevices,
          _vm.defaultOrdersDevices,
          _vm.devices)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.device-name")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('filtrationSystemName', _vm.ordersDevices)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'locationName',
          _vm.ordersDevices,
          _vm.defaultOrdersDevices,
          _vm.devices)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.customer-name")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('locationName', _vm.ordersDevices)))])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleSortOrder(
          'dispServices',
          _vm.ordersDevices,
          _vm.defaultOrdersDevices,
          _vm.devices)
      }
    }
  }, [_c('a', {
    staticClass: "sortable"
  }, [_vm._v("\n                " + _vm._s(_vm.$t("watersystem.service")) + "\n                "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.computeArrowSortOrder('dispServices', _vm.ordersDevices)))])], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    class: ['l-table', _vm.isCustomerFormat ? 'locations' : '']
  }, [(_vm.isCustomerFormat && _vm.locations.length != 0) ? _c('div', [_c('v-expansion-panel', {
    attrs: {
      "expand": "",
      "id": "locations_table"
    }
  }, _vm._l((_vm.locations), function(location, i) {
    return _c('v-expansion-panel-content', {
      key: i,
      ref: "customerExpands",
      refInFor: true,
      staticClass: "grey lighten-4",
      staticStyle: {
        "border-bottom": "1px solid #CCC !important"
      }
    }, [_c('v-layout', {
      attrs: {
        "slot": "header",
        "id": "expansion_row"
      },
      on: {
        "click": function($event) {
          _vm.getEachFiltrationSystems(location.locationId, i, $event)
        }
      },
      slot: "header"
    }, [_c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs1": ""
      }
    }, [(location.locationStatus) ? _c('v-icon', {
      staticClass: "body-2",
      class: location.locationStatus == 1 ? 'orange--text' : 'red--text'
    }, [_vm._v("\n                    fiber_manual_record\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs1": ""
      }
    }, [(location.latitude != null && location.longitude != null) ? _c('v-btn', {
      staticClass: "d-inline-block map_btn ma-0 white",
      attrs: {
        "small": "",
        "depressed": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.centerMapLocation(location.latitude, location.longitude)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    })]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(location.locationName))]), _vm._v(" "), _c('v-flex', {
      staticClass: "grey--text",
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(location.organizationName))]), _vm._v(" "), _c('v-flex', {
      staticClass: "service-header",
      attrs: {
        "xs3": ""
      }
    }, _vm._l((location.services), function(serviceId, index) {
      return _c('span', [(index != 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.shortServiceNames[serviceId]) + "\n                  ")])
    })), _vm._v(" "), _c('v-flex', {
      class: location.activeDevices == 0 ? 'grey--text text--lighten-2' : '',
      attrs: {
        "xs1": ""
      }
    }, [_vm._v(_vm._s(location.activeDevices))])], 1), _vm._v(" "), (!location.filtrationSystems) ? _c('v-card', [_c('v-progress-linear', {
      attrs: {
        "height": "2",
        "indeterminate": true
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-list', [_vm._l((location.filtrationSystems), function(filtrationSystem) {
      return [_c('v-list-tile', {
        key: filtrationSystem.filtrationSystemId,
        staticClass: "ma-0 pa-0",
        class: filtrationSystem.filtrationSystemId == _vm.selectedFiltrationSystemId ? 'blue lighten-4' : 'white',
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.showFiltrationSystem(filtrationSystem.filtrationSystemId)
          }
        }
      }, [_c('v-layout', {
        staticClass: "body-2 grey--text text--darken-2",
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        staticClass: "text-xs-center",
        attrs: {
          "xs1": ""
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.statusCheck(filtrationSystem)) + "\n                          "), (filtrationSystem.status !== 0) ? _c('v-icon', {
        staticClass: "body-2",
        class: filtrationSystem.statusCssClass
      }, [_vm._v("\n                            fiber_manual_record\n                          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs3": "",
          "offset-xs1": ""
        }
      }, [_vm._v(_vm._s(filtrationSystem.filtrationSystemName))]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs3": ""
        }
      }), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs2": ""
        }
      }, _vm._l((filtrationSystem.dispServices), function(service, index) {
        return _c('span', [(index != 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.shortServiceNames[service.serviceId]) + "\n                          ")])
      })), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs1": ""
        }
      }, [_vm._v(_vm._s(filtrationSystem.jm1UniqueId))])], 1), _vm._v(" "), (_vm.userRole !== _vm.viewerRoleName) ? _c('div', [_c('v-menu', {
        ref: "waterSystemMenu",
        refInFor: true,
        attrs: {
          "left": "",
          "offset-y": ""
        }
      }, [_c('v-btn', {
        attrs: {
          "slot": "activator",
          "small": "",
          "flat": "",
          "icon": ""
        },
        on: {
          "click": _vm.showWaterSystemSettingsMenu
        },
        slot: "activator"
      }, [_c('v-icon', {
        staticClass: "caption grey--text"
      }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.showWaterSystemDeleteDialog(filtrationSystem)
          }
        }
      }, [_vm._v("\n                            " + _vm._s(_vm.$t('btn.delete')) + "\n                          ")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider')]
    })], 2)], 1)
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.isCustomerFormat && _vm.locations.length == 0) ? _c('div', [(_vm.message) ? _c('div', {
    staticClass: "pa-3"
  }, [_vm._v("\n            " + _vm._s(_vm.message) + " "), _c('router-link', {
    attrs: {
      "to": "/customer_list"
    }
  }, [_vm._v("here")]), _vm._v(".\n          ")], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isCustomerFormat && _vm.devices.length != 0) ? _c('div', [_c('v-list', {
    staticClass: "pb-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.devices), function(device) {
    return [_c('v-list-tile', {
      class: device.filtrationSystemId == _vm.selectedFiltrationSystemId ? 'blue lighten-4' : 'white',
      attrs: {
        "row": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showFiltrationSystem(device.filtrationSystemId)
        }
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.statusCheck(device)) + "\n                  "), (device.status !== 0) ? _c('v-icon', {
      staticClass: "body-2 pl-2",
      class: device.statusCssClass
    }, [_vm._v("\n                    fiber_manual_record\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_vm._v(_vm._s(device.filtrationSystemName) + " "), _c('span', {
      staticClass: "grey--text"
    }, [_vm._v("(" + _vm._s(device.jm1UniqueId) + ")")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_vm._v(_vm._s(device.locationName))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, _vm._l((device.dispServices), function(service, index) {
      return _c('span', [(index != 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.shortServiceNames[service.serviceId]) + "\n                    ")])
    })), _vm._v(" "), (_vm.userRole !== _vm.viewerRoleName) ? _c('div', [_c('v-menu', {
      ref: "waterSystemMenu",
      refInFor: true,
      attrs: {
        "left": "",
        "offset-y": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "small": "",
        "flat": "",
        "icon": ""
      },
      on: {
        "click": _vm.showWaterSystemSettingsMenu
      },
      slot: "activator"
    }, [_c('v-icon', {
      staticClass: "caption grey--text"
    }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showWaterSystemDeleteDialog(device)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.$t('btn.delete')) + "\n                        ")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider')]
  })], 2)], 1) : _vm._e(), _vm._v(" "), (!_vm.isCustomerFormat && _vm.devices.length == 0) ? _c('div', [(_vm.message) ? _c('div', {
    staticClass: "pa-3"
  }, [_vm._v("\n            " + _vm._s(_vm.message) + "\n          ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "l-detail-wrap"
  }, [_c('div', {
    staticClass: "l_detail_bar lighten-1",
    on: {
      "mousedown": _vm.l_detail_bar_onMouseDown
    }
  }, [_c('v-layout', {
    staticClass: "white--text "
  }, [_c('v-flex', {
    staticClass: "pt-2 pl-2"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("watersystem.deviceinfo")))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('v-icon', {
    staticClass: "white--text mr-4 icon-hover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.changeSize('max')
      }
    }
  }, [_vm._v("vertical_align_top")]), _vm._v(" "), _c('v-icon', {
    staticClass: "white--text mr-4 icon-hover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.changeSize('mid')
      }
    }
  }, [_vm._v("vertical_align_center")]), _vm._v(" "), _c('v-icon', {
    staticClass: "white--text mr-5 icon-hover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.changeSize('min')
      }
    }
  }, [_vm._v("vertical_align_bottom")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "l-detail"
  }, [_c('water-system', {
    ref: "filtrationSystem",
    on: {
      "child-action": _vm.centerMapLocation,
      "delete-succeed": _vm.reloadWaterSystemList
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "l-map"
  }, [_c('v-btn', {
    staticClass: "map_float_btn map_btn elevation-5",
    attrs: {
      "dark": "",
      "small": "",
      "color": "grey",
      "absolute": ""
    },
    on: {
      "click": _vm.mapToggle
    }
  }, [(_vm.active) ? _c('v-icon', [_vm._v("keyboard_arrow_right")]) : _c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "min-height": "90vh",
      "border-left": "3px solid #AAA"
    },
    attrs: {
      "id": _vm.mapName
    }
  })], 1), _vm._v(" "), _c('water-system-delete-dialog', {
    ref: "waterSystemDeleteDialog",
    on: {
      "delete-succeed": _vm.reloadWaterSystemList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-21cb13d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WaterSystemList.vue
// module id = 1912
// module chunks = 0